import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

// export const prefixInjectionFields = "inj" // "INJECTION_"

export const injectionFieldTypes = {
    injectionFields: `injection_field`
    // injectionFields: { id: `injectionFields` }
}

export const scopeTypes = {
    item: {
        id: "item",
        key: "",
        description: "Support product, item, category, ...",
        isMain: true
    },
    document: {
        id: "document",
        key: "doc",
        description: "Support document, document_item, ...",
        isMain: true
    },
    documentItem: {
        id: "document_item",
        key: "doci",
        description: "Subset from document",
        isMain: false
    },
    repository: {
        id: "repository",
        key: "",
        description: "Support repository, package, repository_item, ...",
        isMain: true
    },
    user: {
        id: "user",
        key: "",
        description: "Support customer, retailer, branch, branch_user, ...",
        isMain: true
    },
    branch: {
        id: "branch",
        key: "",
        description: "Support customer, retailer branches",
        isMain: false
    },
    logistic: {
        id: "logistic",
        key: "",
        description: "Support transporter, ...",
        isMain: true
    },
}

export const moduleTypes = {
    item: {
        product: { id: "product", ref: scopeTypes.item.id, module: "product" },
        item: { id: "item", ref: scopeTypes.item.id, module: "item" },
        category: { id: "category", ref: scopeTypes.item.id, module: "category" },
        uom: { id: "uom", ref: scopeTypes.item.id, module: "uom" },
        brand: { id: "brand", ref: scopeTypes.item.id, module: "brand" }
    },
    document: {
        proformaSales: { id: "proforma_sales", ref: scopeTypes.document.id, module: "proforma_sales" },
        cashSales: { id: "cash_sales", ref: scopeTypes.document.id, module: "cash_sales" },
        retailCashSales: { id: "retail_cash_sales", ref: scopeTypes.document.id, module: "retail_cash_sales" },
        salesOrder: { id: "sales", ref: scopeTypes.document.id, module: "sales" },
        salesInvoice: { id: "sales_invoice", ref: scopeTypes.document.id, module: "sales_invoice" },
        deliveryOrder: { id: "delivery", ref: scopeTypes.document.id, module: "delivery" },
        itemReceive: { id: "item_receive", ref: scopeTypes.document.id, module: "item_receive" },
        tripOrder: { id: "trip", ref: scopeTypes.document.id, module: "trip" },
    },
    documentItem: {
        proformaSales: { id: "proforma_sales", ref: scopeTypes.documentItem.id, module: "proforma_sales" },
        cashSales: { id: "cash_sales", ref: scopeTypes.documentItem.id, module: "cash_sales" },
        salesOrder: { id: "sales", ref: scopeTypes.documentItem.id, module: "sales" },
        deliveryOrder: { id: "delivery", ref: scopeTypes.documentItem.id, module: "delivery" },
        itemReceive: { id: "item_receive", ref: scopeTypes.documentItem.id, module: "item_receive" },
    },
    repository: {
        package: { id: "package", ref: scopeTypes.repository.id, module: "package" },
        container: { id: "container", ref: scopeTypes.repository.id, module: "container" },
    },
    user: {
        administrator: { id: "administrator", ref: scopeTypes.user.id, module: "administrator" },
        supplier: { id: "supplier", ref: scopeTypes.user.id, module: "supplier" },
        retailer: { id: "retailer", ref: scopeTypes.user.id, module: "retailer" },
        customer: { id: "customer", ref: scopeTypes.user.id, module: "customer" },
        driver: { id: "driver", ref: scopeTypes.user.id, module: "driver" },
        worker: { id: "worker", ref: scopeTypes.user.id, module: "worker" },
        member: { id: "member", ref: scopeTypes.user.id, module: "member" },
    },
    branch: {
        customer: { id: "customer", ref: scopeTypes.branch.id, module: "customer" },
        retailer: { id: "retailer", ref: scopeTypes.branch.id, module: "retailer" }
    },
    logistic: {
        transporter: { id: "transporter", ref: scopeTypes.logistic.id, module: "transporter" },
    },
}

export const moduleReferences = {
    document: {
        id: "document",
        document: "document_id",
        proformaSales: "document_id",
        cashSales: "document_id",
        retailCashSales: "document_id",
        salesOrder: "document_id",
        salesInvoice: "document_id",
        deliveryOrder: "document_id",
        itemReceive: "document_id",
        tripOrder: "document_id",
    },
    documentItem: {
        id: "document_item",
        proformaSales: "document_item_id",
        cashSales: "document_item_id",
        salesOrder: "document_item_id",
        salesInvoice: "document_item_id",
        deliveryOrder: "document_item_id",
        itemReceive: "document_item_id",
    },
    item: {
        id: "item",
        product: "product_id",
        category: "category_id",
        item: "item_id",
    },
    repository: {
        id: "repository",
        package: "repository_id",
        container: "repository_id",
    },
    user: {
        id: "user",
        administrator: "user_id",
        supplier: "user_id",
        customer: "user_id",
        retailer: "user_id",
        driver: "user_id",
        worker: "user_id",
        member: "user_id",
    },
    branch: {
        id: "branch",
        customer: "branch_id",
        retailer: "branch_id",
    },
    logistic: {
        id: "logistic",
        transporter: "logistic_id"
    }
}

export const fieldDataTypes = {
    id: { id: "id", fieldName: "field_id" },
    text: { id: "text", fieldName: "field_text" },
    value: { id: "value", fieldName: "field_value" },
    numeric: { id: "numeric", fieldName: "field_numeric" },
    integer: { id: "integer", fieldName: "field_integer" },
    timestamp: { id: "timestamp", fieldName: "field_timestamp" },
    date: { id: "date", fieldName: "field_date" },
    date_time: { id: "date_time", fieldName: "field_date_time" },
}

// get field row
export const getUpdateFieldValuesPayload = ({
    items: _items = [{
        key: '',
        module: '',
        ref: '',
        refId: '',
        value: ''
    }]
}) => {

    let injectionFields = _items.map(i => ({
        field_key: `${i.key}`,
        field_module: `${i.module}`,
        field_ref: `${i.ref}`,
        ref_id: `${i.refId}`,
        field_value: `${i.value}`
    }))

    return {
        injection_fields: injectionFields
    }

}

// extract the scheduler ids from the response
// export const getSchedulerRequestIds = (data) => {

//     const resScheduler = data?.schedulers ? data.schedulers : []
//     const schedulerRequestIds = resScheduler.map(i => i?.id)
//     return schedulerRequestIds
// }

// // build and get the object for the create injection props payload
// export const getAppendSchedulerFields = (ids, dataTypes = []) => {

//     if (ids.length <= 0) return {}

//     return {
//         scheduler_request: {
//             scheduler_request_ids: ids,
//             data_types: dataTypes
//         }
//     }
// }

// export const getInjectionValueByFieldName = ({ fieldType = '', targetType = '', fieldName, obj }) => {

//     let fullFieldName = ""

//     // assume fieldName is the full prop name
//     if (fieldType === "" && targetType === "") {
//         fullFieldName = fieldName
//     } else { // using full prop  name
//         fullFieldName = getInjectionFieldFullName({ fieldType, targetType, fieldName })
//     }

//     fullFieldName = fullFieldName.toLowerCase()

//     if (fullFieldName in obj) {
//         return obj[fullFieldName]
//     }
//     return ""
// }

// export const getInjectionFieldFullName = ({ fieldType, targetType, fieldName }) => {

//     let name = `${prefixInjectionFields}_${targetType}_${fieldType}_${fieldName}`
//     return name.toLowerCase()
// }

export function useInjectionFields({
    jwtToken: _jwtToken,
    injectionFieldType: _injectionFieldType,
    scopeType: _scopeType = '',
    // fieldType: _fieldType,
    // targetType: _targetType,
}) {

    // const [fieldType, setFieldType] = useState(_fieldType);
    const [injectionFieldType, setInjectionFieldType] = useState(_injectionFieldType);
    const [scopeType, setScopeType] = useState(_scopeType);
    // const [targetType, setTargetType] = useState(_targetType);

    const { makeCall, getError } = useServerClient(_jwtToken);
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint2 = "injection_fields"
    const endpoint = "injection_field"

    const list = async (props) => {

        let {
            overrideInjectionFieldType
        } = props

        setIsLoading(true);

        try {

            let url = getListsUrl(`${endpoint2}/${injectionFieldType}`, props);

            if (overrideInjectionFieldType) {
                url = getListsUrl(`${endpoint2}/${overrideInjectionFieldType}`, props);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const create = async ({
        data,
        overrideInjectionFieldType,
    }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint}`;

            let postData = {
                scope: {
                    target: _injectionFieldType,
                    action: "",
                },
                payload: data
            }

            if (overrideInjectionFieldType) postData.scope.target = overrideInjectionFieldType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ data, overrideInjectionFieldType = '' }) => {

        setIsLoading(true);

        if (data.length <= 0) {
            throw getError(false, `Please select at least (1) injection field key`)
        }

        try {

            let url = `${endpoint2}/delete`

            const postData = {
                scope: {
                    target: injectionFieldType,
                    action: ""
                },
                payload: data
            }

            if (overrideInjectionFieldType) postData.scope.target = overrideInjectionFieldType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    // insert field values
    const updateFieldValues = async ({
        data,
        overrideScopeType,
    }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint}`;

            let postData = {
                scope: {
                    target: scopeType,
                    action: "",
                },
                payload: data
            }

            if (overrideScopeType) postData.scope.target = overrideScopeType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        fieldDataTypes,
        // scopeTypes,
        getUpdateFieldValuesPayload,
        updateFieldValues,
        list,
        create,
        remove
    }
}